import axios from 'axios';

// Smart backend URL detection
// Always use current origin for API calls to avoid cross-domain issues
const getBackendURL = () => {
  const envBackendURL = process.env.REACT_APP_BACKEND_URL;
  const currentOrigin = window.location.origin;
  
  // Always use current origin - this ensures frontend and backend are on same domain
  // This prevents CORS issues and incorrect backend URLs
  console.log(`[API Config] Using current origin: ${currentOrigin}`);
  if (envBackendURL && envBackendURL !== currentOrigin) {
    console.log(`[API Config] Ignoring env REACT_APP_BACKEND_URL: ${envBackendURL}`);
  }
  
  return currentOrigin;
};

const BACKEND_URL = getBackendURL();
const API = `${BACKEND_URL}/api`;

console.log('[API Config] Backend URL:', BACKEND_URL);

const api = axios.create({
  baseURL: API,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;